import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import {
  showErrorToast,
  // showSuccessToast,
  showSuccessToast2,
  showCenterErrorToast,
} from "../toast";
import axiosInstance from "../../utils/axiosInstance";
import { State } from "country-state-city";
import { Turnstile } from "@marsidev/react-turnstile";
import { useRef } from "react";

import { TURNSTILE_SITE_KEY } from "../../utils/turnstile";

const generateCaptcha = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};


const SnConfirmationForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    experience: "",
    state: "",
    zip: "",
    location: "",
    certificationType: "",
    trainingMode: "Online",
    trainingBatch: "",
    remarks: "",                          // FIX 1: added missing remarks field
    termsAccepted: false,
    promoCode: "",
    stage: "stage2",
    formType: "snconfirmation",
    recordType: "SN confirmation",
  });

  const [turnstileToken, setTurnstileToken] = useState("");
  const turnstileRef = useRef(null);

  const usStates = State.getStatesOfCountry("US");
  const [fields, setFields] = useState([]);
  const [errors, setErrors] = useState({});
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");

  useEffect(() => {
    const fetchFields = async () => {
      try {
        const response = await axiosInstance.get("/api/form-config/snconfirmation");
        setFields(response.data);
      } catch (error) {
        console.error("Error fetching fields:", error);
        showErrorToast("Failed to load form fields. Please try again later.");
      }
    };
    fetchFields();
  }, []);

  const getField = (name) =>
    Array.isArray(fields)
      ? fields.find((f) => f.fieldName?.toLowerCase() === name.toLowerCase()) || null
      : null;

  const certificationField = getField("Certification Type");
  const trainingModeField = getField("Training Mode");
  const trainingBatchField = getField("Training Batch");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email))
      newErrors.email = "Invalid email address";
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    }
    else if (formData.phone.replace(/\D/g, "").length < 10) {
      newErrors.phone = "Enter valid phone number";
    }
    if (!formData.experience) newErrors.experience = "Experience is required";
    else if (formData.experience < 0) newErrors.experience = "Experience cannot be negative";
    if (!formData.location.trim()) newErrors.location = "Location is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.zip.trim()) newErrors.zip = "Zip Code is required";
    if (!formData.certificationType) newErrors.certificationType = "Please select certification type";
    if (!formData.trainingBatch) newErrors.trainingBatch = "Please select training batch";
    if (!formData.termsAccepted) newErrors.termsAccepted = "You must accept Terms and Conditions";
    // if (!captchaInput.trim()) newErrors.captcha = "Captcha is required";
    // else if (captchaInput !== captcha) newErrors.captcha = "Captcha does not match";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleApiError = (error) => {

    if (!error.response) {
      showErrorToast(
        "Server not reachable. Please try again later."
      );
      return;
    }

    const { status, data } = error.response;

    if (status === 409) {

      showCenterErrorToast("Email already exists");

      // Clear old Turnstile token
      setTurnstileToken("");

      // Generate a new Turnstile challenge/token
      turnstileRef.current?.reset();

      return;
    }

    if (status === 403) {

      setTurnstileToken("");

      turnstileRef.current?.reset();

      setErrors((prev) => ({
        ...prev,
        turnstile:
          data?.message ||
          "Turnstile verification failed."
      }));

      return;
    }

    showErrorToast(
      "Something went wrong. Please try again."
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    if (!turnstileToken) {
      setErrors((prev) => ({
        ...prev,
        turnstile: "Please complete the verification.",
      }));

      return;
    }

    try {
      const requestData = {
        ...formData,
        turnstileToken: turnstileToken,
      };
      setLoading(true);

      await axiosInstance.post("/api/snconformation/register", requestData);
      // showSuccessToast("Thanks for registering for ServiceNow Training. Please check email for details.");
      showSuccessToast2("Your training registration is successful. Please check email for next steps. Our office staff will contact you within next business day.", { duration: Infinity })
      setFormData({
        fullName: "", email: "", phone: "", experience: "",
        state: "", zip: "", location: "",
        certificationType: "",
        trainingMode: "Online",
        trainingBatch: "",
        remarks: "",
        termsAccepted: false,
        promoCode: "",
        stage: "stage2",
        formType: "snconfirmation",
        recordType: "SN confirmation",
      });
      setErrors({});
      setCaptcha(generateCaptcha());
      setCaptchaInput("");
      turnstileRef.current?.reset();
      setTurnstileToken("");
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-section py-2 bg-confirm">
      {loading && <Loader />}

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12 col-xl-12">
            <div className="card border-0 shadow-lg rounded-4">
              <div className="card-body py-space">
                {window.innerWidth >= 768 ? (
                  // <fieldset className="border borderfield rounded-4 p-3 w-100 mb-2">
                  //   <legend className="float-none w-auto px-2 fw-bold text-primary content-heading1 content-heading2">
                  //     ServiceNow Special Training - Confirmation Details
                  //   </legend>
                  //   <div className="text-center">
                  //     <img
                  //       src={flierImage}
                  //       alt="ServiceNow Special Training Flier"
                  //       className="img-fluid rounded-3 w-100"
                  //       style={{ maxHeight: "420px", objectFit: "contain" }}
                  //     />
                  //   </div>
                  // </fieldset>
                  <div className="text-center mb-4">
                    <h3 className="fw-bold text-primary content-heading1 content-heading2">
                      ServiceNow Special Training - Confirmation Details
                    </h3>
                  </div>

                ) : (
                  <>
                    <div className="text-center mb-4">
                      <h3 className="fw-bold text-primary content-heading1 content-heading2">
                        ServiceNow Special Training - Confirmation Details
                      </h3>
                    </div>
                    {/* <div className="mb-4 text-center">
                      <img
                        src={flierImage}
                        alt="ServiceNow Special Training Flier"
                        className="img-fluid rounded-3 w-100"
                        style={{ maxHeight: "420px", objectFit: "cover" }}
                      />
                    </div> */}
                  </>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row align-items-stretch">

                    {/* ===== LEFT CARD: PERSONAL DETAILS ===== */}
                    <div className="col-lg-6 mb-4 d-flex">
                      <fieldset className="border borderfield rounded-4 p-3 w-100">
                        <legend className="float-none w-auto px-3 fw-semibold text-secondary legend-gradient">
                          Personal Details
                        </legend>

                        <div className="row g-3">
                          <div className="col-md-6">
                            <label className="form-label">
                              Your Full Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded-3"
                              name="fullName"
                              value={formData.fullName}
                              onChange={handleChange}
                            />
                            <small className="text-danger">{errors.fullName}</small>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">
                              Email ID <span className="text-danger">*</span>
                            </label>
                            <input
                              type="email"
                              className="form-control rounded-3"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                            <small className="text-danger">{errors.email}</small>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">
                              Phone Number <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded-3"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                            />
                            <small className="text-danger">{errors.phone}</small>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">
                              Years of IT Experience <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              className="form-control rounded-3"
                              name="experience"
                              value={formData.experience}
                              onChange={handleChange}
                            />
                            <small className="text-danger">{errors.experience}</small>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">
                              Location (City) <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control rounded-3"
                              name="location"
                              value={formData.location}
                              onChange={handleChange}
                            />
                            <small className="text-danger">{errors.location}</small>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">
                              State <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select rounded-3"
                              name="state"
                              value={formData.state}
                              onChange={handleChange}
                            >
                              <option value="">-- Select State --</option>
                              {usStates.map((state) => (
                                <option key={state.name} value={state.name}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                            <small className="text-danger">{errors.state}</small>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">
                              Zip Code <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control rounded-3"
                              name="zip"
                              value={formData.zip}
                              onChange={handleChange}
                            />
                            <small className="text-danger">{errors.zip}</small>
                          </div>
                        </div>
                      </fieldset>
                    </div>

                    {/* ===== RIGHT CARD: TRAINING DETAILS ===== */}
                    <div className="col-lg-6 mb-4 d-flex">
                      <fieldset className="border borderfield rounded-4 p-3 w-100">
                        <legend className="float-none w-auto px-3 fw-semibold text-secondary legend-gradient">
                          Training Details
                        </legend>

                        {/* FIX 4: remarks moved inside row g-3 with proper col-12 wrapper */}
                        <div className="row g-3">
                          <div className="col-12">
                            <label className="form-label">
                              Certification Type <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select rounded-3"
                              name="certificationType"
                              value={formData.certificationType}
                              onChange={handleChange}
                            >
                              {/* FIX 5: added placeholder option so empty value is selectable */}

                              {certificationField &&
                                certificationField.options.map((option, index) => (
                                  <option key={option.value || index} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                            </select>
                            <small className="text-danger">{errors.certificationType}</small>
                          </div>

                          <div className="col-12">
                            <label className="form-label">
                              Training Mode <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select rounded-3"
                              name="trainingMode"
                              value={formData.trainingMode}
                              onChange={handleChange}
                            >
                              {trainingModeField &&
                                trainingModeField.options.map((option, index) => (
                                  <option key={option.value || index} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="col-12">
                            <label className="form-label">
                              Training Batch <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select rounded-3"
                              name="trainingBatch"
                              value={formData.trainingBatch}
                              onChange={handleChange}
                            >
                              {/* FIX 5 (cont.): added placeholder option for trainingBatch too */}

                              {trainingBatchField &&
                                trainingBatchField.options.map((option, index) => (
                                  <option key={option.value || index} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                            </select>
                            <small className="text-danger">{errors.trainingBatch}</small>
                          </div>

                          {/* FIX 4: remarks now inside row g-3, properly wrapped in col-12 */}
                          <div className="col-12">
                            <label className="form-label">Remarks</label>
                            <textarea
                              className="form-control rounded-3"
                              rows="3"
                              name="remarks"
                              value={formData.remarks}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>

                  {/* PROMOCODE */}
                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <label className="form-label">
                        Promo Code
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        name="promoCode"
                        value={formData.promoCode}
                        onChange={handleChange}
                        placeholder="Enter promo code"
                      />
                      <small className="text-danger">{errors.promoCode}</small>
                    </div>
                  </div>

                  {/* ===== PAYMENT INFO ===== */}
                  <div className="p-3 bg-light border rounded-3 mb-3 bg-light-blue">
                    <h6 className="fw-bold mb-2">
                      Training Fees Payment&nbsp;&nbsp;
                      <span className="text-highlight">
                        Fee details emailed after registration
                      </span>{" "}
                      |{" "}
                      <span className="text-highlight">
                        Flex Pay Options available.
                      </span>
                      <span className="text-danger"> *</span>
                    </h6>
                    {/* <h6 style={{ fontSize: "12px", color: "#000" }}>( Fee details emailed after registration )</h6>
                    <small className="text-muted text-highlight">
                   
                      <span className="d-block">Flex Pay Options available.</span>
                    </small> */}
                  </div>

                  {/* ===== TERMS ===== */}
                  <label className="form-check-label mb-2">
                    <strong>Terms and Conditions <span className="text-danger">*</span></strong>
                  </label>
                  <div className="form-check mb-4">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="termsAccepted"
                      checked={formData.termsAccepted}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">
                      By submitting this form, I agree to the Terms and Conditions
                      to be signed electronically via DocuSign.
                    </label>
                    <small className="text-danger d-block">{errors.termsAccepted}</small>
                  </div>

                  <div className="mb-3 d-flex flex-column align-items-center">
                    <Turnstile
                      siteKey={TURNSTILE_SITE_KEY}
                      theme="light"
                      size="normal"
                      ref={turnstileRef}
                      onSuccess={(token) => {
                        setTurnstileToken(token);

                        setErrors((prev) => ({
                          ...prev,
                          turnstile: ""
                        }));
                      }}
                      onExpire={() => setTurnstileToken("")}
                      onError={() => setTurnstileToken("")}

                    />

                    <small className="text-danger d-block mt-1">
                      {errors.turnstile}
                    </small>
                  </div>
                  {/* Captcha */}
                  {/* <div className="mb-2">
                    <label>Captcha</label>
                    <div className="d-flex align-items-center gap-3">
                      <input
                        className="form-control text-center"
                        value={captchaInput}
                        onChange={(e) => setCaptchaInput(e.target.value)}
                        style={{ maxWidth: "200px" }}
                      />
                      <strong className="px-3 py-2 bg-light border rounded">
                        {captcha}
                      </strong>
                      <Button
                        type="button"
                        variant="light"
                        onClick={() => {
                          setCaptcha(generateCaptcha());
                          setCaptchaInput("");
                        }}
                      >
                        <FontAwesomeIcon icon={faRotateRight} />
                      </Button>
                    </div>
                    <small className="text-danger">{errors.captcha}</small>
                  </div> */}

                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-primary w-100 rounded-3 fw-semibold submitbtn"
                    >
                      Register and Pay (later)
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SnConfirmationForm;